/**
 * Abstract class to be implemented by any service that provides a remote assets storage service;
 * @export
 */
export abstract class RemoteAssetsService {
    /**
     * Return the file url from a given path.
     */
    abstract getFileUrl(path: string): any;
}
